export const SITE_PILOTS_TABLE_FRENCH_LOCALE = {
  headers: {
    serialNumber: "Numéro de série",
    csId: "Cs Id",
    hwId: "Hardware Id",
    operator: "Opérateur",
    lastConnectionDate: "Dernière connexion",
    softwareVersion: "Version logicielle",
    installationDate: "Date d'installation",
  },
  empty: "Aucun pilote trouvé...",
};
